export var DialogEnum;
(function (DialogEnum) {
    DialogEnum[DialogEnum["Confirm"] = 0] = "Confirm";
    DialogEnum[DialogEnum["Cancel"] = 1] = "Cancel";
})(DialogEnum || (DialogEnum = {}));
//# sourceMappingURL=DialogEnum.js.map